import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';

import { colors } from 'settings/theme';
import Typography from 'components/vistaprintUILibrary/Typography';
import DesignerSpotlight from 'components/DesignerSpotlight';

function DesignerSpotlightSwitcher(props) {
  const {
    selectedDesignerId,
    selectedDesignerOnChange,
    designers,
  } = props;

  const selectedDesigner = designers.find(designer => designer.id === selectedDesignerId);

  return (
    <div
      style={{
        marginBottom: 50,
      }}
    >
      <DesignerSpotlight
        name={selectedDesigner.name}
        quote={selectedDesigner.quote}
        highlights={selectedDesigner.highlights}
        profileImageSrc={selectedDesigner.profileImageSrc}
        workSampleImageSrc={selectedDesigner.workSampleImageSrc}
      />
      <Row>
        <Col>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: 20,
            }}
          >
            <div
              style={{
                height: 1,
                width: '80%',
                backgroundColor: colors.border,
              }}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {designers.map(designer => (
              <div
                key={`designer-spotlight-${designer.id}`}
              >
                <button
                  type="button"
                  onClick={() => selectedDesignerOnChange(designer.id, designer.name)}
                  style={{
                    // remove default button styles
                    border: 'none',
                    backgroundColor: 'unset',
                    outline: 'none', // removing outline is okay because we add our own outline to the image

                    marginTop: 4,
                    marginBottom: 4,
                    marginLeft: 10,
                    marginRight: 10,
                    padding: 4,
                  }}
                >
                  <img
                    src={designer.profileImageSrc}
                    alt={designer.name}
                    style={{
                      height: 55,
                      width: 55,
                      padding: 3,
                      marginBottom: 5,
                      borderRadius: '50%',
                      boxShadow: designer.id === selectedDesignerId ? `0 0 0 2px ${colors.blueMid}` : 'none',
                    }}
                  />
                  <Typography text={designer.name} />
                </button>
              </div>
            ))}
          </div>
        </Col>
      </Row>

    </div>
  );
}

DesignerSpotlightSwitcher.propTypes = {
  selectedDesignerId: PropTypes.number.isRequired,
  selectedDesignerOnChange: PropTypes.func.isRequired,
  designers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.name,
    workSampleImageSrc: PropTypes.string,
    profileImageSrc: PropTypes.string,
    highlights: PropTypes.arrayOf(PropTypes.shape({
      iconSrc: PropTypes.string,
      text: PropTypes.string,
    })),
    quote: PropTypes.string,
  })).isRequired,
};

export default DesignerSpotlightSwitcher;



// WEBPACK FOOTER //
// ./src/components/DesignerSpotlightSwitcher.js